import {
  ADMIN_DELETE_USER_START,
  ADMIN_DELETE_USER_SUCCESS,
  ADMIN_DELETE_USER_ERROR
} from '../../constants';
import history from '../../core/history';
import { deleteUser as mutation } from '../../lib/graphql';
import showToaster from '../../helpers/toasterMessages/showToaster';

export function deleteUser(userId) {
  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: ADMIN_DELETE_USER_START,
        data: userId
      });
      let isAdmin = getState()?.runtime?.isAdminAuthenticated;

      const { data } = await client.mutate({
        mutation,
        variables: { userId, userType: "admin" }
      });

      if (data.deleteUser.status == "success") {
        dispatch({
          type: ADMIN_DELETE_USER_SUCCESS,
        });
        isAdmin ? showToaster({ messageId: 'deleteUser', toasterType: 'success' }) : showToaster({ messageId: 'deleteUserAccount', toasterType: 'success' })
        isAdmin ? history.push('/siteadmin/users') : history.push('/')
        return {
          status: 200
        }
      } else if (data.deleteUser.status == "activebooking") {
        dispatch({
          type: ADMIN_DELETE_USER_ERROR,
        });
        isAdmin ? showToaster({ messageId: 'deleteUserDetails', toasterType: 'error', requestMessage: data.deleteUser.errorMessage }) : showToaster({ messageId: 'deleteUserAccountFailed', toasterType: 'error' })
        return {
          status: 400
        }
      } else {
        showToaster({ messageId: 'deleteUserFailed', toasterType: 'error' })
        return {
          status: 400
        }
      }

    } catch (error) {
      dispatch({
        type: ADMIN_DELETE_USER_ERROR,
        payload: {
          error
        }
      });
      return {
        status: 400
      }
    }
  };
}
